export const pushLearnMoreCtaClickDataLayer = (
  items: Record<string, any>[],
  selectedProject?: { label: string; id: string },
) => {
  if (!items?.length) {
    return;
  }
  dataLayer.push({
    event: 'learn_more_cta_click',
    location: 'digital_sampling',
    event_location: 'Quick-View',
    event_project_name: selectedProject?.label,
    event_project_id: selectedProject?.id,
    event_item_id: items[0].item_id,
    event_item_name: items[0].item_name,
    event_item_brand: items[0].item_brand,
    event_item_category: items[0].item_category,
    event_item_category2: items[0].item_category2,
    event_item_category3: items[0].item_category3,
    event_item_variant: items[0].item_variant,
    event_item_list_id: 'digital_sampling_mini_pdp',
    event_item_list_name: 'Digital Sampling Mini PDP',
  });
};
